import { EMPTY_VALUE } from '../constants';
import type { DrugTestReport, DrugTestResolution, DrugTestStatusHistoryItem } from '../types';

/** Status cell: `Original → New` (dash when original missing). */
export const getHistoryTransitionLabel = (
  original: string | null | undefined,
  next: string | null | undefined
): string => {
  const from = original?.trim() ? original : EMPTY_VALUE;
  const to = next?.trim() ? next : EMPTY_VALUE;
  return `${from} → ${to}`;
};

/**
 * Panel subtitle headline after transition count.
 * Prefer terminal resolution labels Consider / Withdrawn; otherwise current status.
 */
export const getHistoryHeadline = (report: DrugTestReport | null): string => {
  if (!report) return EMPTY_VALUE;
  const resolution = report.resolution as DrugTestResolution | null;
  if (resolution === 'consider') return 'Consider';
  if (resolution === 'withdrawn') return 'Withdrawn';
  return report.status?.trim() || EMPTY_VALUE;
};

/** Panel count: `N transition(s) · Headline`. */
export const getHistoryPanelCountLabel = (count: number, report: DrugTestReport | null): string => {
  const safe = Number.isFinite(count) ? Math.max(0, Math.trunc(count)) : 0;
  const unit = safe === 1 ? 'transition' : 'transitions';
  return `${safe} ${unit} · ${getHistoryHeadline(report)}`;
};

export const getHistoryStatusLabel = (item: DrugTestStatusHistoryItem): string =>
  getHistoryTransitionLabel(item.original_status, item.new_status);

export const getHistoryResolutionLabel = (item: DrugTestStatusHistoryItem): string =>
  getHistoryTransitionLabel(item.original_resolution, item.new_resolution);
